import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b42fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "music-title" }, "*标题:")
  ])
], -1))
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "music-title" }, "*版本名:")
  ])
], -1))
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "music-title" }, "*版本号:")
  ])
], -1))
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "music-music" }, "*安装包:")
  ])
], -1))
const _hoisted_17 = { class: "d-flex flex-row mb-1" }
const _hoisted_18 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.title) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.item.title]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.version) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.item.version]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.code) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.item.code]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.url) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.item.url]
                    ]),
                    _createVNode(_component_FileUploader, { onUpload: _ctx.fileUpload }, null, 8, ["onUpload"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}